
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.5 0c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9zm4.406 9.914h-3.821v4.046c0 .343-.263.622-.588.622-.325 0-.588-.279-.588-.622V9.914H5.088c-.325 0-.588-.28-.588-.623 0-.344.263-.622.588-.622h3.821V4.622c0-.343.263-.622.588-.622.325 0 .588.279.588.622V8.67h3.821c.325 0 .588.278.588.622s-.263.623-.588.623z","fill":"#515358","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/add.svg